import React, { useState } from 'react';
import { Typography } from '@mui/material';

import PhoneBase from '../../Interface/PhoneBase/PhoneBase';
import TabsUI from '../../Interface/TabsUI';
import InprogressDelivery from './InprogressDelivery';
import NewDelivery from './NewDelivery';
import DeliveryDocsTab from './DeliveryDocsTab';

const DeliveryPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Bizonylatok',
      content: <DeliveryDocsTab />,
    },
    {
      id: 1,
      name: 'Új indítása',
      content: <NewDelivery />,
    },
    {
      id: 2,
      name: 'Folyamatban',
      content: <InprogressDelivery />,
    },
  ];

  return (
    <PhoneBase name="Delivery">
      <Typography variant="h5" sx={{ fontWeight: 400, py: 1, px: 2 }}>
        Kiszállítás
      </Typography>
      <TabsUI activeTab={activeTab} handleTabClick={setActiveTab} disablePadding>
        {tabs.map((tab) => (
          <div key={tab.id} name={tab.name}>
            {tab.content}
          </div>
        ))}
      </TabsUI>
    </PhoneBase>
  );
};

export default DeliveryPage;
